<div class="common-container">
  <p class="common-info">Invite users to collaborate on this workspace. You can adjust their roles later.</p>
  @if (userManagementIsLoading$ | async) {
    <mat-progress-spinner [diameter]="40" mode="indeterminate"></mat-progress-spinner>
  }
</div>

<div class="document-content">
  <h3 *appRequiredRoles="['admin']" class="section-title">Invite New User</h3>
  <form *appRequiredRoles="['admin']" [formGroup]="inviteFormGroup" class="invite-form">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Email Address</mat-label>
      <input matInput formControlName="email" placeholder="user@domain.com" />
      @if (!!inviteFormControls.email.errors?.['required']) {
        <mat-error>Email is required</mat-error>
      }
      @if (!!inviteFormControls.email.errors?.['email']) {
        <mat-error>Must be a valid email</mat-error>
      }
      @if (!!inviteFormControls.email.errors?.['emailExists']) {
        <mat-error>Email in list already exist</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field role-field">
      <mat-label>Select Role</mat-label>
      <mat-select formControlName="role">
        @for (role of roleOptions; track role) {
          <mat-option [value]="role">
            {{ role | titlecase }}
          </mat-option>
        }
      </mat-select>

      @if (!!inviteFormControls.role.errors?.['invalid']) {
        <mat-error>Role is invalid</mat-error>
      }
      @if (!!inviteFormControls.role.errors?.['required']) {
        <mat-error>Role is required</mat-error>
      }
    </mat-form-field>

    <button
      [disabled]="inviteFormGroup.disabled || (isDisabledEdit$ | async)"
      mat-raised-button
      color="primary"
      (click)="onSubmitInvite()"
      class="invite-button">
      @if (!inviteFormGroup.disabled) {
        <mat-icon>mail_outline</mat-icon>
      } @else {
        <mat-icon>hourglass_empty</mat-icon>
      }
      Invite
    </button>
  </form>

  @if (users$ | async; as users) {
    <h3 class="section-title">Workspace Users ({{ users.length }})</h3>

    <table mat-table [dataSource]="users" class="full-width-table">
      <ng-container matColumnDef="role_icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <mat-icon [color]="user.role === 'admin' ? 'accent' : 'primary'" [matTooltip]="user.role | titlecase">
            {{ user.role === 'admin' ? 'security' : 'person' }}
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let user">{{ user.role | titlecase }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let user">
          <app-status-chip
            [status]="user.status === 'active' ? 'primary' : user.status === 'pending' ? 'warn' : 'error'">
            {{ user.status | titlecase }}
          </app-status-chip>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
        <td mat-cell *matCellDef="let user" class="actions-cell">
          <div class="actions-buttons">
            <button
              *appRequiredRoles="['admin']"
              [disabled]="deleteUsers[user.id] || (isDisabledEdit$ | async)"
              mat-icon-button
              (click)="onDeleteUser(user)"
              matTooltip="Remove User">
              <mat-icon>delete</mat-icon>
            </button>
            <mat-form-field *appRequiredRoles="['admin']" class="role-change-select" appearance="outline">
              <mat-select
                [value]="user.role"
                [disabled]="changeRoleUsers[user.id] || (isDisabledEdit$ | async)"
                (selectionChange)="onChangeRole(user, $event.value)">
                @for (role of roleOptions; track role) {
                  <mat-option [value]="role">
                    {{ role | titlecase }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell empty-data-source" [attr.colspan]="displayedColumns.length">No users in this workspace.</td>
      </tr>
    </table>
  }
</div>
